export default __webpack_public_path__ + "static/media/download_red.da0fa948.svg";